import {
  ClusterDbType,
  DboCacheStatus,
  DboCacheStatusConditions,
  DboEvent,
  DboEventType,
  DbProtocolType,
} from '@cast/types';

export type DeployMethod = 'curl' | 'helm';

export type DboDirectModeEvent = DboEvent & {
  eventType:
    | typeof DboEventType.DIRECT_MODE_DISABLED
    | typeof DboEventType.DIRECT_MODE_ENABLED;
};

export enum DbInstanceType {
  RDS = 'rds',
  MANUAL = 'manual',
  UNKNOWN = 'unknown',
}

export type DbComponentType = 'Instance' | 'Cluster' | 'Manual Component';

export type CacheMetrics = {
  totalQueries?: number;
  dqlQueries?: number;
  cacheHits?: number;
  potentialCacheHits?: number;
  hitRate?: number;
  potentialHitRate?: number;
  totalDbTime?: number;
  timeSavedPercent?: number;
  potentialTimeSavedPercent?: number;
  load?: number;
};

export type CacheDbCount = {
  total?: number;
  cacheEnabled?: number;
};

export type ConnectionsMetricsSource = {
  databaseTotalConnections?: number;
  databaseIdleConnections?: number;
  dboTotalConnections?: number;
  dboIdleConnections?: number;
};

export type ConnectionsSummary = {
  total?: number;
  idle?: number;
  active?: number;
};

export type InstancePrice = {
  current?: number;
  savings?: number;
  savingsPercent?: number;
};

export type InstanceRowModel = {
  id: string;
  name: string;
  instanceId?: string;
  clusterId?: string;
  cacheGroupId?: string;
  componentType: DbComponentType;
  instanceType: DbInstanceType;
  instanceFamily?: string;
  clusterType?: ClusterDbType;
  dbType: DbProtocolType;
  dbCount: CacheDbCount;
  price: InstancePrice;
  metrics: CacheMetrics;
  cacheStatus?: DboCacheStatus;
  cacheStatusConditions?: DboCacheStatusConditions;
  directMode: boolean;
  roxy?: boolean;
  performanceInsightsDisabled?: boolean;
};
